
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import { moneyFormat } from "@/utils/util";
import { getWorkbenchOverviewData, getWorkbenchOverviewDataShop } from "@/api/shouyin";
import { Getter } from 'vuex-class';

// 总览数据
@Component({
  components: {
    CardContainer,
  },
})
export class OverviewData extends Vue {
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  @Prop({ default: () => ({}) }) params!: any;

  isInit = false;
  moneyFormat = moneyFormat;
  grid = [
    {
      label: "销售金额",
      value: 0,
      prop: "totalOrderMoney",
      isMoney: true,
    },
    {
      label: "销售笔数",
      value: 0,
      prop: "totalOrderCount",
      isMoney: false,
    },
    {
      label: "客单价",
      value: 0,
      prop: "avgOrderMoney",
      isMoney: true,
    },
    {
      label: "毛利率",
      value: "0%",
      prop: "marginRate",
      isMoney: false,
    },
  ];
  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  async getData() {
    this.isInit = false;
    let res: any;
    if (this.isMultiStore) {
      const params = {
        orderType: this.params.orderType,
        queryTimeBegin: this.params.queryTimeBegin,
        queryTimeEnd: this.params.queryTimeEnd,
        storeList: this.multiStoreList.map((item) => {
          return { storeId: item };
        }),
      };
      res = await getWorkbenchOverviewDataShop(params);
    } else {
      res = await getWorkbenchOverviewData(this.params);
    }
    console.log("查询总览数据 ***", res.data);
    this.grid.forEach((item: any) => {
      const v = res.data[item.prop] || 0;
      item.value = item.prop === "marginRate" && v === 0 ? "--" : v;
    });
    this.isInit = true;
  }
}
export default OverviewData;
